import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'
import 'firebase/compat/functions'
import 'firebase/compat/app-check'

export const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  projectId: process.env.VUE_APP_PROJECTID,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPID
  // measurementId: process.env.VUE_APP_MEASUREMENTID
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

// Initialize App Check (if site key is provided). This helps satisfy Cloud Functions App Check enforcement.
if (process.env.VUE_APP_RECAPTCHA_V3_SITE_KEY) {
  try {
    // eslint-disable-next-line no-console
    console.log('[FIREBASE] Inicializando AppCheck con reCAPTCHA v3')
    const appCheck = firebase.appCheck()

    // Habilitar debug tokens en desarrollo
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log('[FIREBASE] Habilitando debug tokens para AppCheck en desarrollo')
      // eslint-disable-next-line no-undef
      self.FIREBASE_APPCHECK_DEBUG_TOKEN = true
    }

    appCheck.activate(
      new firebase.appCheck.ReCaptchaV3Provider(process.env.VUE_APP_RECAPTCHA_V3_SITE_KEY),
      {
        isTokenAutoRefreshEnabled: true
      }
    )
    // eslint-disable-next-line no-console
    console.log('[FIREBASE] AppCheck inicializado correctamente')
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[FIREBASE] Error al inicializar AppCheck:', error)
    // eslint-disable-next-line no-console
    console.log('[FIREBASE] Continuando sin AppCheck')
  }
} else {
  // eslint-disable-next-line no-console
  console.warn('[FIREBASE] No se encontró clave de reCAPTCHA v3, AppCheck no estará disponible')
}

export default firebase
export const auth = firebase.auth()
export const db = firebase.firestore()
export const storage = firebase.storage()
// Use compat default Functions instance (region defaults to the deployed one)
export const functions = firebase.functions()

// Quiz
export const quizRef = db.collection('quiz').orderBy('date', 'desc')
export const teachersRef = db.collection('teachers').orderBy('created_at', 'desc')
export const classStudentsRef = db.collectionGroup('classStudents').orderBy('created_at', 'desc')
export const classesRef = db.collection('classes').where('finished', '==', false).orderBy('created_at', 'desc')
export const materialsRef = db.collection('materials').orderBy('order').orderBy('created_at', 'desc')
